import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/observable/of';

import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

import {
    PageState
} from './qs-checks-controlling-home.reducer';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {
    GetSaisonUebersichtAction
} from '../../../../client-ngrx/qschecks';
import {
    PageStateResetAction,
    SAISON_UEBERSICHT_LADEN, SAISON_UEBERSICHT_NEU_LADEN, SaisonUebersichtLadenAction, SaisonUebersichtNeuLadenAction
} from './qs-checks-controlling-home.actions.ui';
import {SaisonUebersichtRequest} from '../../../../clients/qschecks';
import {UuidService} from '@orga-app/providers/uuid.service';
import {getPrueferRollenIds, getPruefplanId, getSaisonIdListe} from './qs-checks-controlling-home.selectors';

@Injectable()
export class QsChecksControllingHomeUiEffects {

    @Effect()
    neuLaden$: Observable<Action> = this.actions$.pipe(
        ofType<SaisonUebersichtNeuLadenAction>(SAISON_UEBERSICHT_NEU_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanId)),
            this.store$.pipe(select(getSaisonIdListe)),
            this.store$.pipe(select(getPrueferRollenIds)))
        , filter(([x, pruefplanId, saisonIdListe, prueferRolleIds]) => pruefplanId !== null && saisonIdListe !== null && saisonIdListe.length > 0 && prueferRolleIds !== null)
        , map(([x, pruefplanId, saisonIdListe, prueferRolleIds]) => {
            const request: SaisonUebersichtRequest = {
                pruefplan_id: pruefplanId,
                saison_id_liste: saisonIdListe,
                pruefer_rolle_ids: prueferRolleIds,
            };
            return new GetSaisonUebersichtAction(request);
        })
    );

    @Effect()
    aktuelleSaisonUebersichtLaden$: Observable<Action> = this.actions$.pipe(
        ofType<SaisonUebersichtLadenAction>(SAISON_UEBERSICHT_LADEN)
        , filter((x) => x.payload !== null)
        , map((x) => {
            const request: SaisonUebersichtRequest = {
                pruefplan_id: x.payload.pruefplanId,
                saison_id_liste: x.payload.saisonIds,
                pruefer_rolle_ids: x.payload.rollenIds,
            };
            return new GetSaisonUebersichtAction(request);
        })
    );

    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store$: Store<PageState>) {
    }
}
